import API from 'utils/api';
import getFormattedValues, { hasFiles } from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = '/nominas/incidencias-empleados-adjuntos';
const headers = { 'Content-Type': 'multipart/form-data' };
const files = ['archivo'];
// /**
//  * GET Documentos Empleados
//  * @param {object} params
//  * @returns {Promise<object[]>}
//  */
// export const getDocumentosEmpleados = async () => {
//   try {
//     const response = await API.get(baseURI);
//     return response.data;
//   } catch (err) {
//     onError(err);
//   }
//   return [];
// };

/**
 * GET Documento Empleado
 * @param {object} params
 * @returns {Promise<object|null>}
 */
export const getDocumentoIncidenciaEmpleado = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * GET Documentos Empleados params
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getDocumentosIncidenciasEmpleados = async (params) => {
  try {
    const response = await API.get(`${baseURI}`, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * POST Documento Empleado
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postDocumentoIncidenciaEmpleado = (formData) => API.post(`${baseURI}/`, formData, {
  headers: {
    'Content-Type': 'multipart/form-data',
  },
});
/**
 * PATCH Documento Empleado
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchDocumentoIncidenciaEmpleado = async (id, values) => {
  try {
    // const config = hasFiles(values, files) ? { headers } : {};
    /* const formattedValues = getFormattedValues(values, {
      files,
      formData: config.headers,
      clean: true,
    });* */
    //  const response = await API.patch(`${baseURI}/${id}`, formattedValues);
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
/**
 * DELETE Documento Empleado
 * @param {number} id
 * @return {Promise<boolean>}
 */
export const deleteDocumentoIncidenciaEmpleado = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PUT Documentos Empleado Status
 * @param {object} values
 * @returns {Promise<{}>}
 */
export const putDocumentoIncidenciaEmpleadoStatus = async (values) => {
  try {
    const response = await API.put('catalogos/actualizar-documentos-empleado-status', values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
